import { render } from "./BankAccountList.vue?vue&type=template&id=0b03d042&ts=true"
import script from "./BankAccountList.vue?vue&type=script&lang=ts"
export * from "./BankAccountList.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__